module.exports = ol.style.Stroke;